import * as React from 'react';

import image from './icons/icon-not-found.svg';
import Styles from './style.module.scss';

export interface NotFoundProps {
    title?: string;
    description?: string;
    icon?: string;
}

const NotFound = (props: NotFoundProps) => {
    const { title, description, icon } = props;

    return (
        <div className={Styles.NotFound}>
            <div className={Styles.NotFoundImage}>
                <img alt={title} src={icon} />
            </div>

            {title && <div className={Styles.NotFoundTitle}>{title}</div>}

            {description && <div className={Styles.NotFounDescriptiond}>{description}</div>}
        </div>
    );
};

NotFound.defaultProps = {
    title: 'Not Found',
    description: '',
    icon: image,
};

export default NotFound;
